// B1.4: move-only from client.ts.
import { ApiClientCore, buildQueryString } from './http/core';

export class ProductUpdatesApi extends ApiClientCore {
  async acknowledgeProductUpdate(id: number): Promise<any> {
    return this.post<any>(`/api/v1/product-updates/my/${id}/acknowledge`, {});
  }
  async archiveProductUpdate(id: number): Promise<any> {
    return this.post(`/api/v1/product-updates/super/drafts/${id}/archive`, {});
  }
  async createProductUpdateDraft(data: {
    title: string;
    summary: string;
    changes: string[];
    body: string;
    target_modules: string[];
    target_roles: string[];
  }): Promise<any> {
    return this.post('/api/v1/product-updates/super/drafts', data);
  }
  async deleteProductUpdateDraft(id: number): Promise<void> {
    return this.delete(`/api/v1/product-updates/super/drafts/${id}`);
  }
  async getMyProductUpdate(id: number): Promise<any> {
    return this.get<any>(`/api/v1/product-updates/my/${id}`);
  }
  // ─── Wallet (hospitality) ───────────────────────────────────────────────────
  async getMyProductUpdates(params: { limit?: number; offset?: number; only_unread?: boolean } = {}): Promise<{
    items: any[];
    total: number;
  }> {
    return this.get<{ items: any[]; total: number }>(`/api/v1/product-updates/my${buildQueryString(params)}`);
  }
  async getProductUpdateDraft(id: number): Promise<any> {
    return this.get(`/api/v1/product-updates/super/drafts/${id}`);
  }
  async getProductUpdateDrafts(params: { status?: string; limit?: number; offset?: number } = {}): Promise<{ items: any[]; total: number }> {
    return this.get(`/api/v1/product-updates/super/drafts${buildQueryString(params)}`);
  }
  async publishProductUpdate(id: number): Promise<any> {
    return this.post(`/api/v1/product-updates/super/drafts/${id}/publish`, {});
  }
  async replyToProductUpdate(
    id: number,
    message: string,
    locationId?: number | null
  ): Promise<{ room_id: number; support_case_id: number; message: string }> {
    const body: { message: string; location_id?: number } = { message };
    if (locationId != null && Number.isFinite(Number(locationId))) {
      body.location_id = Number(locationId);
    }
    return this.post<{ room_id: number; support_case_id: number; message: string }>(
      `/api/v1/product-updates/my/${id}/reply`,
      body
    );
  }
  async resendProductUpdateNotifications(id: number): Promise<any> {
    return this.post(`/api/v1/product-updates/super/drafts/${id}/resend-notifications`, {});
  }
  async updateProductUpdateDraft(
    id: number,
    data: {
      title?: string;
      summary?: string;
      changes?: string[];
      body?: string;
      target_modules?: string[];
      target_roles?: string[];
    }
  ): Promise<any> {
    return this.patch(`/api/v1/product-updates/super/drafts/${id}`, data);
  }
}
